import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function BlogNewsletter() {
  return <section className="bg-[#ECECEC] py-[48px] lg:py-[80px]" data-id="element-365">
      <div className="max-w-[600px] mx-auto px-6 lg:px-8" data-id="element-366">
        <AnimateOnScroll className="text-center" data-id="element-367">
          <h2 className="text-[28px] lg:text-[40px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-368">
            STAY IN THE KNOW
          </h2>

          <p className="text-[#333333] text-base font-body mb-8" data-id="element-369">
            Get the latest tips, treatments, and exclusive offers delivered to
            your inbox
          </p>

          {/* Desktop: inline form */}
          <form className="hidden sm:flex mb-4" onSubmit={e => e.preventDefault()} data-id="element-370">
            <input type="email" placeholder="Enter your email" className="flex-1 px-5 py-3.5 text-base border border-[#CCCCCC] bg-white text-black rounded-l focus:outline-none focus:ring-2 focus:ring-[#FF1493] focus:border-[#FF1493] font-body min-h-[48px]" data-id="element-371" />
            <button type="submit" className="bg-[#FF1493] text-white uppercase font-bold text-sm tracking-widest px-7 py-3.5 rounded-r hover:bg-[#D4117A] transition-colors font-[Poppins,_sans-serif] min-h-[48px]" data-id="element-372">
              SUBSCRIBE
            </button>
          </form>

          {/* Mobile: stacked form */}
          <form className="sm:hidden flex flex-col gap-2 mb-4" onSubmit={e => e.preventDefault()} data-id="element-373">
            <input type="email" placeholder="Enter your email" className="w-full px-5 py-3.5 text-base border border-[#CCCCCC] bg-white text-black rounded focus:outline-none focus:ring-2 focus:ring-[#FF1493] focus:border-[#FF1493] font-body min-h-[48px]" data-id="element-374" />
            <button type="submit" className="w-full bg-[#FF1493] text-white uppercase font-bold text-sm tracking-widest px-7 py-3.5 rounded hover:bg-[#D4117A] transition-colors font-[Poppins,_sans-serif] min-h-[48px]" data-id="element-375">
              SUBSCRIBE
            </button>
          </form>

          <p className="text-[#999999] text-xs font-body" data-id="element-376">
            No spam, ever. Unsubscribe anytime.
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}